import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HrReportRow, HrRetentionReport } from "models/hr-reports";

// Rows for each HR report. null = not loaded yet (or the last load failed).
export interface HrReportsSliceState {
    demographics: HrReportRow[] | null;
    anniversary: HrReportRow[] | null;
    retention: HrRetentionReport | null;
}

const initialState: HrReportsSliceState = {
    demographics: null,
    anniversary: null,
    retention: null,
};

const HrReportsSlice = createSlice({
    name: "HrReports",
    initialState,
    reducers: {
        setDemographicsReport(state, action: PayloadAction<HrReportRow[] | null>) {
            state.demographics = action.payload;
        },
        setAnniversaryReport(state, action: PayloadAction<HrReportRow[] | null>) {
            state.anniversary = action.payload;
        },
        setRetentionReport(state, action: PayloadAction<HrRetentionReport | null>) {
            state.retention = action.payload;
        },
    },
});

export const { setDemographicsReport, setAnniversaryReport, setRetentionReport } = HrReportsSlice.actions;

export default HrReportsSlice.reducer;
